/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class MarketplaceApi extends runtime.BaseAPI {
    /**
     * Copy a predefined marketplace dashboard into the current account.
     * Copy Marketplace Dashboard
     */
    async copyMarketplaceDashboardRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling copyMarketplaceDashboard().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/marketplace/dashboards/{profile_id}/copy`;
        urlPath = urlPath.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Copy a predefined marketplace dashboard into the current account.
     * Copy Marketplace Dashboard
     */
    async copyMarketplaceDashboard(requestParameters, initOverrides) {
        const response = await this.copyMarketplaceDashboardRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Stream a marketplace image without granting general file access.
     * Get Marketplace Asset
     */
    async getMarketplaceAssetRaw(requestParameters, initOverrides) {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError('fileId', 'Required parameter "fileId" was null or undefined when calling getMarketplaceAsset().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/marketplace/assets/{file_id}`;
        urlPath = urlPath.replace(`{${"file_id"}}`, encodeURIComponent(String(requestParameters['fileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.BlobApiResponse(response);
    }
    /**
     * Stream a marketplace image without granting general file access.
     * Get Marketplace Asset
     */
    async getMarketplaceAsset(requestParameters, initOverrides) {
        const response = await this.getMarketplaceAssetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the marketplace metadata and derived information for one dashboard.
     * Get Marketplace Dashboard
     */
    async getMarketplaceDashboardRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling getMarketplaceDashboard().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/marketplace/dashboards/{profile_id}`;
        urlPath = urlPath.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get the marketplace metadata and derived information for one dashboard.
     * Get Marketplace Dashboard
     */
    async getMarketplaceDashboard(requestParameters, initOverrides) {
        const response = await this.getMarketplaceDashboardRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List predefined marketplace dashboards with pagination.
     * Get Marketplace Dashboards
     */
    async getMarketplaceDashboardsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }
        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/marketplace/dashboards`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List predefined marketplace dashboards with pagination.
     * Get Marketplace Dashboards
     */
    async getMarketplaceDashboards(requestParameters = {}, initOverrides) {
        const response = await this.getMarketplaceDashboardsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update marketplace presentation metadata without changing dashboard content.
     * Update Marketplace Dashboard Metadata
     */
    async updateMarketplaceDashboardMetadataRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling updateMarketplaceDashboardMetadata().');
        }
        if (requestParameters['marketplaceProfileMetadata'] == null) {
            throw new runtime.RequiredError('marketplaceProfileMetadata', 'Required parameter "marketplaceProfileMetadata" was null or undefined when calling updateMarketplaceDashboardMetadata().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/marketplace/dashboards/{profile_id}/metadata`;
        urlPath = urlPath.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['marketplaceProfileMetadata'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Update marketplace presentation metadata without changing dashboard content.
     * Update Marketplace Dashboard Metadata
     */
    async updateMarketplaceDashboardMetadata(requestParameters, initOverrides) {
        const response = await this.updateMarketplaceDashboardMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Publish or unpublish a marketplace dashboard.
     * Update Marketplace Dashboard Publication
     */
    async updateMarketplaceDashboardPublicationRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling updateMarketplaceDashboardPublication().');
        }
        if (requestParameters['marketplacePublicationPayload'] == null) {
            throw new runtime.RequiredError('marketplacePublicationPayload', 'Required parameter "marketplacePublicationPayload" was null or undefined when calling updateMarketplaceDashboardPublication().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/marketplace/dashboards/{profile_id}/publication`;
        urlPath = urlPath.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['marketplacePublicationPayload'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Publish or unpublish a marketplace dashboard.
     * Update Marketplace Dashboard Publication
     */
    async updateMarketplaceDashboardPublication(requestParameters, initOverrides) {
        const response = await this.updateMarketplaceDashboardPublicationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Upload and assign the Marketplace image for a dashboard.
     * Upload Marketplace Dashboard Image
     */
    async uploadMarketplaceDashboardImageRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling uploadMarketplaceDashboardImage().');
        }
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError('file', 'Required parameter "file" was null or undefined when calling uploadMarketplaceDashboardImage().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file']);
        }
        let urlPath = `/api/v2/marketplace/dashboards/{profile_id}/image`;
        urlPath = urlPath.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Upload and assign the Marketplace image for a dashboard.
     * Upload Marketplace Dashboard Image
     */
    async uploadMarketplaceDashboardImage(requestParameters, initOverrides) {
        const response = await this.uploadMarketplaceDashboardImageRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
